import React from 'react'
import { Outlet } from 'react-router-dom'

function MainSurveyReport() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainSurveyReport